
export const drawCaptchaToCanvas = (
  canvas: HTMLCanvasElement,
  text: string,
  padding = 40,
  fontSize = 34,
  fontFamily = "Georgia"
) => {
  const ctx = canvas.getContext("2d");
  if (!ctx) return;

  const charWidth = fontSize * 0.7;
  const width = text.length * charWidth + padding;
  const height = fontSize + 30;

  canvas.width = width;
  canvas.height = height;

  ctx.fillStyle = "#f2f2f2";
  ctx.fillRect(0, 0, width, height);

  for (let i = 0; i < 25; i++) {
    ctx.strokeStyle = `rgba(0,0,0,${Math.random()})`;
    ctx.beginPath();
    ctx.moveTo(Math.random() * width, Math.random() * height);
    ctx.lineTo(Math.random() * width, Math.random() * height);
    ctx.stroke();
  }

  ctx.font = `${fontSize}px ${fontFamily}`;
  ctx.fillStyle = "#000";
  ctx.setTransform(1, 0.15, 0.2, 1, 0, 0);
  ctx.fillText(text, 20, fontSize);
  ctx.setTransform(1, 0, 0, 1, 0, 0);
};

export const generateRandomText = (length = 6): string => {
  const chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ@!#$%^&*";
  return Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join("");
};
